import React, { useState, useEffect, useRef } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';

/* const KeyCodes = {
  enter: 13,
};
 */
//const separators = [KeyCodes.enter];

const ReactTagsDemo = React.forwardRef((props, ref) => {
  const [tags, setTags] = useState([]);
  const [tagsValue, setTagsValue] = React.useState('');
  const inputText = useRef();
  if (ref) {
    inputText.current = ref.current;
  }

  const { clearTags } = props;

  useEffect(() => {
    setTags([]);
    setTagsValue('');
    if (inputText.current) {
      inputText.current.value = '';
    }
  }, [clearTags]);

  const handleAddition = (tag) => {
    setTags([...tags, tag]);
    setTagsValue([...tagsValue, tag.text]);
  };

  const handleDrag = (tag, currPos, newPos) => {
    const newTags = [...tags].slice();
    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);
    setTags(newTags);
  };

  const onRemove = (i) => {
   /*  setTags(tags.filter((_, index) => index !== i));
    setTagsValue(tagsValue.filter((_, index) => index !== i).join(''));
    if (tagsValue.filter((_, index) => index !== i).length === 0) {
      setTagsValue('');
    } */
      setTags(tags.filter((tag, index) => index !== i));
      setTagsValue(tagsValue.filter((tag, index) => index !== i));
      var test = tagsValue.filter((tag, index) => index !== i);
      if(test.length === 0){
        setTagsValue('');
      }
  };

  const preventFirstSpace = (e) => {
    if (e === ' ') {
      inputText.current = '';
      var str = document.getElementById('tags');
      str.value = '';
    }
  };

  return (
    <div className="app pt2-sm pr4-sm pb2-sm pl4-sm">
      <div ref={inputText}>
        <ReactTags
          handleDelete={onRemove}
          handleAddition={handleAddition}
          handleDrag={handleDrag}
          //separators={separators}
          placeholder="Search..."
          readOnly={false}
          tags={tags}
          inputFieldPosition="inline"
          handleInputBlur={props.onChange(tagsValue)}
          handleInputChange={preventFirstSpace}
          name="searchTerm"
          id="tags"
          autoFocus={true}
        />
      </div>
    </div>
  );
});

const renderMultiTag = ({ input: { onChange }, clearTags }) => (
  <ReactTagsDemo onChange={onChange} clearTags={clearTags} />
);

export default renderMultiTag;
